import { render } from "./FooterCompo.vue?vue&type=template&id=706bd1e7&scoped=true"
import script from "./FooterCompo.vue?vue&type=script&lang=js"
export * from "./FooterCompo.vue?vue&type=script&lang=js"

import "./FooterCompo.vue?vue&type=style&index=0&id=706bd1e7&scoped=true&lang=css"

import exportComponent from "D:\\Dev\\VueJS\\jobapply-TH\\jobapplyvuejs\\Vue\\vue-crud-netcoreapi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706bd1e7"]])

export default __exports__